import http from "../http-common";

export const getCompanyByUser = async (userId) => {
  const response = await http.get(`/company/getCompanyByUser/${userId}`);
  return response.data;
};

export const updateCompanyByUser = async (userId, payload) => {
  const response = await http.put(`/company/updateCompanyByUser/${userId}`, payload);
  return response.data;
};
